import {cookies} from "./cookies";


export const clearAuthCookies = () => {
    cookies.remove('token');
    cookies.remove('tokenExpiresAt');
    cookies.remove('businessKey');
    cookies.remove('refreshToken');
}